export const ADID_QUERY_PARAM: string = 'adid';

export const ADID_COOKIE: string = 'adid';
